import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ShieldOff } from "lucide-react";

interface DeviceBrowserBlockedContentProps {
  deviceId: string;
}

export const DeviceBrowserBlockedContent = ({ deviceId }: DeviceBrowserBlockedContentProps) => {
  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-lg font-medium">Browser Blocked</h3>
        <p className="text-muted-foreground">Browser access is currently disabled for this device</p>
      </div>

      <Card>
        <CardContent className="flex flex-col items-center justify-center py-8">
          <ShieldOff className="w-12 h-12 text-destructive mb-4" />
          <h4 className="text-lg font-semibold mb-2">Browser Access Disabled</h4>
          <p className="text-sm text-muted-foreground text-center max-w-md">
            The browser is currently blocked on this device. To enable browser access, change the browser setting to "Yes Browser" in the dropdown menu.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};